var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSecuritysettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.831,
    height: 46.831,
    viewBox: "0 0 46.831 46.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-gear-svgrepo-com",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47920",
    "data-name": "Group 47920",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47919",
    "data-name": "Group 47919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55064",
    "data-name": "Path 55064",
    d: "M45.01,19.505l-3.78-1.453A18.94,18.94,0,0,0,39.3,13.4l1.651-3.7a1.272,1.272,0,0,0-.262-1.416L37.54,5.143a1.272,1.272,0,0,0-1.416-.262l-3.7,1.651A18.94,18.94,0,0,0,27.77,4.6L26.326.812A1.283,1.283,0,0,0,25.135,0h-4.43a1.261,1.261,0,0,0-1.191.812L18.053,4.6A18.94,18.94,0,0,0,13.4,6.532L9.7,4.881a1.272,1.272,0,0,0-1.416.262L5.143,8.291a1.272,1.272,0,0,0-.262,1.416l1.651,3.7A18.94,18.94,0,0,0,4.6,18.062L.821,19.514A1.278,1.278,0,0,0,0,20.705v4.43a1.269,1.269,0,0,0,.821,1.191L4.6,27.779a18.94,18.94,0,0,0,1.931,4.655l-1.651,3.7a1.272,1.272,0,0,0,.262,1.416l3.149,3.14a1.272,1.272,0,0,0,1.416.262l3.7-1.651a18.94,18.94,0,0,0,4.655,1.931l1.453,3.789a1.283,1.283,0,0,0,1.191.812h4.43a1.271,1.271,0,0,0,1.182-.812l1.462-3.789A18.94,18.94,0,0,0,32.434,39.3l3.7,1.651a1.272,1.272,0,0,0,1.416-.262l3.14-3.149a1.272,1.272,0,0,0,.262-1.416l-1.651-3.7A18.94,18.94,0,0,0,41.23,27.77l3.78-1.453a1.278,1.278,0,0,0,.821-1.191V20.7A1.269,1.269,0,0,0,45.01,19.505Zm-1.723,4.746L39.7,25.631a1.271,1.271,0,0,0-.785.911,16.093,16.093,0,0,1-2.12,5.115,1.263,1.263,0,0,0-.09,1.2l1.561,3.51-1.895,1.895L32.858,36.7a1.288,1.288,0,0,0-1.2.09,16.215,16.215,0,0,1-5.115,2.12,1.271,1.271,0,0,0-.911.785l-1.38,3.591h-2.68L20.2,39.7a1.271,1.271,0,0,0-.911-.785,16.3,16.3,0,0,1-5.115-2.12,1.263,1.263,0,0,0-1.2-.09l-3.51,1.561L7.569,36.367l1.561-3.51a1.288,1.288,0,0,0-.09-1.2,16.215,16.215,0,0,1-2.12-5.115,1.271,1.271,0,0,0-.785-.911L2.544,24.26V21.58L6.135,20.2a1.271,1.271,0,0,0,.785-.911,16.093,16.093,0,0,1,2.12-5.115,1.263,1.263,0,0,0,.09-1.2L7.569,9.464,9.464,7.569l3.51,1.561a1.288,1.288,0,0,0,1.2-.09,16.339,16.339,0,0,1,5.115-2.12,1.271,1.271,0,0,0,.911-.785l1.371-3.591h2.68l1.38,3.591a1.271,1.271,0,0,0,.911.785,16.3,16.3,0,0,1,5.115,2.12,1.263,1.263,0,0,0,1.2.09l3.51-1.561,1.895,1.895L36.7,12.974a1.288,1.288,0,0,0,.09,1.2,16.339,16.339,0,0,1,2.12,5.115,1.271,1.271,0,0,0,.785.911l3.591,1.371v2.68Z",
    transform: "translate(0 0)",
    fill: "#387f75",
    stroke: "#387f75",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47922",
    "data-name": "Group 47922",
    transform: "translate(8.778 8.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47921",
    "data-name": "Group 47921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55065",
    "data-name": "Path 55065",
    d: "M111.437,97.3a14.137,14.137,0,1,0,14.137,14.137A14.154,14.154,0,0,0,111.437,97.3Zm0,25.731a11.593,11.593,0,1,1,11.593-11.593A11.607,11.607,0,0,1,111.437,123.031Z",
    transform: "translate(-97.3 -97.3)",
    fill: "#387f75",
    stroke: "#387f75",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47924",
    "data-name": "Group 47924",
    transform: "translate(17.97 16.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47923",
    "data-name": "Group 47923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55066",
    "data-name": "Path 55066",
    d: "M209.051,189.72l-1.254-5.1a4.461,4.461,0,0,0,.83-2.607,4.527,4.527,0,0,0-4.592-4.52,4.641,4.641,0,0,0-4.448,4.782,4.47,4.47,0,0,0,.866,2.418l-1.236,5.025a1.272,1.272,0,0,0,1.236,1.579H207.8A1.292,1.292,0,0,0,209.051,189.72Zm-6.974-.965,1.173-4.791-.523-.505a1.977,1.977,0,1,1,3.338-1.434,1.953,1.953,0,0,1-.577,1.389l-.505.505,1.191,4.836Z",
    transform: "translate(-199.179 -177.495)",
    fill: "#387f75",
    stroke: "#387f75",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSecuritysettings);
export default __webpack_public_path__ + "static/media/settings-securitysettings.81d996ccdc51fcb4c0d51b19ab416771.svg";
export { ForwardRef as ReactComponent };